import { ConceptValueDataType } from '@fusion-advantage/backcompat'
import { PrescriptionReviewConcept } from "@fusion-advantage/formlib"
import L4MedicationReconciliationTable from "./L4MedicationReconciliationTable"
import L4MedicationReconciliationTableActions from "./L4MedicationReconciliationTableActions"
import { useConceptValidator } from "./useConceptValidator"

export const L4MedicationReconciliation = () => {
	const { errorNode } = useConceptValidator({
		tagName: 'L4MedicationReconciliation',
		cid: PrescriptionReviewConcept.cid,
		requireConcept: true,
		allowDataTypes: [ConceptValueDataType.Object],
	})
	if(errorNode) {
		return errorNode
	}
	return (
		<>
			<L4MedicationReconciliationTableActions />
			<L4MedicationReconciliationTable />
		</>
	)
}
